import PropertyInfoModalError from './PropertyInfoModalError';

export default PropertyInfoModalError;
